<template>
  <div class="w-100 border rounded shadow p-md-3 px-lg-4">
    <div class="row">
      <div v-if="viewMode" class="col-lg-12 pr-lg-4 pr-3">
        <lot-details-header
          :header-title="`${cpv.code} ${planDetails.cpv_drop ? `/ ${planDetails.cpv_drop}` : ''} - ${cpv.name}`"
          :unit="cpv.unit"
          :unit-amount="planDetailsData.unit_amount"
          :unit-ru="cpv.unit_ru"
          :header-title-ru="cpv.name_ru"
          :planned-count="organizedRow.count"
          :cpv-specification="cpvSpecification"
        />
      </div>
      <div v-else class="col-lg-12 pr-lg-4 pr-3">
        <lot-details-form 
          :header-title="`${cpv.code} ${planDetails.cpv_drop ? `/ ${planDetails.cpv_drop}` : ''} - ${cpv.name}`"
          :cpvName="cpv.name"
          :cpvNameRu="cpv.name_ru"
          :unit="planDetails.unit"
          :unit-amount="planDetailsData.unit_amount"
          :unit-ru="cpv.unit_ru"
          :header-title-ru="cpv.name_ru"
          :planned-count="organizedRow.count"
          :rowDetails="rowDetails"
          :cpv-specification="cpvSpecification"
          @save="save"
        />
      </div>
    </div>
    <button v-if="viewMode && mode === 'edit'" @click="edit" class="btn btn-primary mt-3" type="button">
      Խմբագրել
      <i class="ml-1 fas fa-edit"></i>
    </button>
    <!-- <button @click="save" class="btn btn-primary mt-3" type="button" :disabled="isSaving">
      <span v-if="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      Պահպանել
    </button> -->
  </div>
</template>

<script>
  import LotDetailsHeader from '@/components/dashboard/lot/itender/LotDetailsHeader'
  import LotDetailsForm from '@/components/dashboard/lot/itender/LotDetailsForm'

  export default {
    name: 'LotDetailsFormItender',
    components: { LotDetailsHeader, LotDetailsForm },
    props: {
      rowDetails: Object,
    },
    data() {
      return {
        cpv: {},
        mode: '',
        viewMode: true,
        organizedRow: {
          percent: {},
          count: '',
          supply: '',
          supply_date: '',
          // is_phased_version: null,
          is_main_tool: '',
          is_collateral_requirement: '',
          is_product_info: '',
          shipping_address: '',
        },
        selectedIsCondition: false,
        planDetails: {},
        planDetailsData: {},
        planRowDetails: {},
        cpvSpecification: {},
        isSaving: false,
      }
    },
    computed: {
      typeLabel() {
        if(_.isEmpty(this.planDetails)) {
          return ''
        }
        const labelsObj = {
          1: 'Մատակարարման',
          2: 'Ծառայության մատուցման',
          3: 'Աշխատանքի կատարման ',
        }
        return labelsObj[this.planDetails.cpv_type]
      },
      organizedRows() {
          return this.$store.getters['organizeItender/organizedRows']
      },
      lotPercents() {
        return this.$store.getters['organizeItender/lotPercents']
      },
    },
    async mounted() {
      this.cpvType = this.$route.query.cpvType
      this.mode = this.$route.query.mode
      this.selectedIsCondition = this.rowDetails.is_condition
      await this.$client.get(`organize-row/${this.rowDetails.id}`).then(async({ data: { data } }) => {
        this.organizedRow = Object.assign(this.organizedRow, {
          id: data.id,
          count: data.count,
          supply: data.supply,
          supply_date: data.supply_date,
          is_main_tool: data.is_main_tool,
          is_collateral_requirement: data.is_collateral_requirement,
          is_product_info: data.is_product_info,
          shipping_address: {
            hy: data.shipping_address.hy || '',
            ru: data.shipping_address.ru || '',
          },
        })
        if (data.organizeRowPercent) {
          this.organizedRow = Object.assign(this.organizedRow, {
            percent: _.pick(data.organizeRowPercent, [...Array.from({ length: 12 }, (_, i) => `month_${i + 1}`), 'name', 'organize_row_id']),
          })
          this.planRowDetails = data.procurementPlan.details[0]
        } else {
          if(this.lotPercents){
            this.organizedRow = Object.assign(this.organizedRow, {
            percent: {
              id: data.id,
              month_1: this.lotPercents.month_1,
              month_2: this.lotPercents.month_2,
              month_3: this.lotPercents.month_3,
              month_4: this.lotPercents.month_4,
              month_5: this.lotPercents.month_5,
              month_6: this.lotPercents.month_6,
              month_7: this.lotPercents.month_7,
              month_8: this.lotPercents.month_8,
              month_9: this.lotPercents.month_9,
              month_10: this.lotPercents.month_10,
              month_11: this.lotPercents.month_11,
              month_12: this.lotPercents.month_12
            }})
          }else{
            this.organizedRow = Object.assign(this.organizedRow, {id: data.id})
          }
        }
        this.planDetails = data.procurementPlan
        this.planDetailsData = data.procurementPlan.details[0]

        // getting specification for cpv
        this.cpv = data.procurementPlan.is_from_outside ? data.procurementPlan.cpv_outside : data.procurementPlan.cpv
        this.cpvSpecification = data.procurementPlan.specifications
      })
    },
    methods: {
      edit(){
        this.viewMode = false;
      },
      consoleLog(msg, data) {
        console.log(msg, data)
      },
      save() {
        this.isSaving = true;
        this.$client.get(`organize-row/${this.rowDetails.id}`).then(async({ data: { data } }) => {
          this.organizedRow = Object.assign(this.organizedRow, {
            id: data.id,
            count: data.count,
            supply: data.supply,
            supply_date: data.supply_date,
            is_main_tool: data.is_main_tool,
            is_collateral_requirement: data.is_collateral_requirement,
            is_product_info: data.is_product_info,
            shipping_address: {
              hy: data.shipping_address.hy || '',
              ru: data.shipping_address.ru || '',
            },
          })
          console.log('this.organizedRow', this.organizedRow)
          if (data.organizeRowPercent) {
            this.organizedRow = Object.assign(this.organizedRow, {
              percent: _.pick(data.organizeRowPercent, [...Array.from({ length: 12 }, (_, i) => `month_${i + 1}`), 'name', 'organize_row_id']),
            })
            this.planRowDetails = data.procurementPlan.details[0]
          } else {
            if(this.lotPercents){
              this.organizedRow = Object.assign(this.organizedRow, {
              percent: {
                id: data.id,
                month_1: this.lotPercents.month_1,
                month_2: this.lotPercents.month_2,
                month_3: this.lotPercents.month_3,
                month_4: this.lotPercents.month_4,
                month_5: this.lotPercents.month_5,
                month_6: this.lotPercents.month_6,
                month_7: this.lotPercents.month_7,
                month_8: this.lotPercents.month_8,
                month_9: this.lotPercents.month_9,
                month_10: this.lotPercents.month_10,
                month_11: this.lotPercents.month_11,
                month_12: this.lotPercents.month_12
              }})
            }else{
              this.organizedRow = Object.assign(this.organizedRow, {id: data.id})
            }
          }
          this.planDetails = data.procurementPlan
          this.planDetailsData = data.procurementPlan.details[0]
          this.cpv = data.procurementPlan.is_from_outside ? data.procurementPlan.cpv_outside : data.procurementPlan.cpv
          this.cpvSpecification = data.procurementPlan.specifications;
          this.viewMode = true;
        })
        console.log(this.cpvSpecification, 'cpvSpecification')
        // Object.assign(this.organizedRow.percent, {name: 'name', ...this.$refs.percents.percents})

        // const isFirst = this.organizedRow.id === this.organizedRows[0].id;
        // if(isFirst){
        //   this.$client.post('organize-row/autoInsertPercents', this.organizedRow)
        // }

        // this.$client.put(`organize-row/${this.organizedRow.id}`, this.organizedRow).then(response => {
        //   this.isSaving = false
        // }).catch(e => {
        //   this.isSaving = false
        // })
      },
    },
  }
</script>

<style>
  .months {
    min-width: 115px;
    text-align: center;
    display: inline-block;
  }
  .percents {
    width: 18px; 
    padding: 0; 
    align-items: center; 
    justify-content: center;
  }
  .percent-input-arrows {
    cursor:pointer;
    left: -12px;
    font-size: large
  }
</style>
